import { io } from "socket.io-client";
import { API_URL } from "./Constants";
import { currentUser } from "./CurrentUser";
import { notify } from "components/ToastNotification";
let socket;

export const initializeSocket = () => {
    socket = io(API_URL, {
        transports: ["websocket"], // Use WebSocket for faster communication
    });

    socket.emit("register", { token: currentUser.token })

    socket.emit("joinQuiz", { token: currentUser.token })

    socket.on("connect", () => {
        // console.log("Connected to the server with ID:", socket.id);
    });

    socket.on("disconnect", () => {
        // console.log("Disconnected from the server.");
    });

    // Handle errors
    socket.on("error", (data) => {
        // console.error("Error received:", data.output);
        notify(data.output, 'error');
    });

    // Handle registration confirmation
    socket.on("register", (data) => {
        // console.log("User registered successfully:", data);
    });

    return socket;
};

export const getSocket = () => {
    initializeSocket();
    if (!socket) {
        throw new Error("Socket not initialized. Call initializeSocket first.");
    }
    return socket;
};
